export default __webpack_public_path__ + "static/media/Holidaze-logo-white.beb00b7c.png";